import { UniUniPickupWarehouse } from "@redotech/redo-model/carrier-account/create-carrier-account";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export const UniUniCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  clientSecret: input<string>({ validator: nonEmptyValidator }),
  customerNumber: input<string>({ validator: nonEmptyValidator }),
  pickupWarehouse: input<UniUniPickupWarehouse>({
    validator: nonEmptyValidator,
  }),
});

export type UniUniCarrierValue = InputSchema.Value<typeof UniUniCarrierInput>;

export type UniUniCarrierForm = InputSchema.Input<typeof UniUniCarrierInput>;

export const UniUniCarrierDefault = (): UniUniCarrierValue => ({
  clientId: "",
  clientSecret: "",
  customerNumber: "",
  pickupWarehouse: "ATL",
});

const pickupWarehouseOptions: RedoListItem<UniUniPickupWarehouse>[] =
  UniUniPickupWarehouse.map((code) => ({
    id: code,
    type: "text",
    text: code,
    value: code,
  }));

export const CreateUniUniCarrierForm = memo(function CreateUniUniCarrierForm({
  carrierInput,
}: {
  carrierInput: UniUniCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Client ID"
        placeholder=""
        setValue={carrierInput.inputs.clientId.setValue}
        value={carrierInput.inputs.clientId.value}
      />
      <RedoTextInput
        label="Client secret"
        placeholder=""
        setValue={carrierInput.inputs.clientSecret.setValue}
        value={carrierInput.inputs.clientSecret.value}
      />
      <RedoTextInput
        label="Customer number"
        placeholder=""
        setValue={carrierInput.inputs.customerNumber.setValue}
        value={carrierInput.inputs.customerNumber.value}
      />
      <RedoSingleSelectDropdownInput
        label="Pickup warehouse"
        options={pickupWarehouseOptions}
        optionSelected={({
          item,
        }: {
          item: RedoListItem<UniUniPickupWarehouse>;
        }) => {
          carrierInput.inputs.pickupWarehouse.setValue(item.value);
        }}
        selectedItem={pickupWarehouseOptions.find(
          (option) =>
            option.value === carrierInput.inputs.pickupWarehouse.value,
        )}
      />
    </>
  );
});
